import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=3e9e255a"
import script from "./ChoosePlan.vue?vue&type=script&lang=js"
export * from "./ChoosePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports